/*
* Output format of the generated audio.
* */
export enum ElevenLabsOutputFormats {
    /*
    * mp3 with 44.1kHz sample rate at 64kbps.
    **/
    "mp3_44100_64" = "mp3_44100_64",

    /*
    * mp3 with 44.1kHz sample rate at 96kbps.
    * */
    "mp3_44100_96" = "mp3_44100_96",

    /*
    * mp3 with 44.1kHz sample rate at 128kbps.
    * */
    "mp3_44100_128" = "mp3_44100_128",

    /*
    * mp3 with 44.1kHz sample rate at 192kbps.
    * Requires you to be subscribed to Creator tier or above.
    * */
    "mp3_44100_192" = "mp3_44100_192",

    /*
    * PCM format (S16LE) with 22.05kHz sample rate.
    * */
    "pcm_22050" = "pcm_22050",

    /*
    * PCM format (S16LE) with 24kHz sample rate
    * */
    "pcm_24000" = "pcm_24000",

    /*
    * PCM format (S16LE) with 44.1kHz sample rate.
    * Requires you to be subscribed to Independent Publisher tier or above.
    * */
    "pcm_44100" = "pcm_44100",

    /*
    * μ-law format (sometimes written mu-law, often approximated as u-law) with 8kHz sample rate. Note that this format
    * is commonly used for Twilio audio inputs.
    * */
    "ulaw_8000" = "ulaw_8000"
}
